import '../../App.css'


export default function FlightSoftware() {
    return (
      <h2>flight-software</h2>
    
    );
  }